const collection = {
  slug: "comme-des-garcons-homme-plus-2027ss-if-the-war-were-to-end-guide",
  metaTitle:
    "COMME des GARCONS HOMME PLUS 2027SS もし、戦争が終わったら｜買取・レンタルガイド",
  metaDescription:
    "COMME des GARCONS HOMME PLUS 2027SS『If The War Were To End.. / もし、戦争が終わったら』を解説。2015SS『Peace Army』、2025AW『To Hell With War』から続く反戦表現、ミリタリーの解体、パステルカモフラージュ、旗、ストライプ、タータン、軽やかなシルエットから、戦争後の服を読み解き、COMME des GARCONS HOMME PLUS買取・レンタル導線へ案内します。",
  metaKeywords:
    "COMME des GARCONS HOMME PLUS 2027SS,COMME des GARÇONS HOMME PLUS 2027SS,COMME des GARCONS HOMME PLUS2027SS,コムデギャルソンオムプリュス 2027SS,コムデギャルソンオムプリュス2027SS,コムデギャルソンオムプリュス 2027春夏,If The War Were To End,もし戦争が終わったら,もし、戦争が終わったら,コムデギャルソンオムプリュス もし戦争が終わったら,コムデギャルソンオムプリュス 戦争,コムデギャルソンオムプリュス 平和の軍隊,COMME des GARCONS HOMME PLUS Peace Army,COMME des GARCONS HOMME PLUS To Hell With War,コムデギャルソンオムプリュス TO HELL WITH WAR,コムデギャルソンオムプリュス ミリタリー,COMME des GARCONS HOMME PLUS ミリタリー,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソンオムプリュス レンタル,COMME des GARCONS HOMME PLUS レンタル,Enclopedia,アンクロペディア",
  canonicalPath:
    "/archive_collection/comme-des-garcons-homme-plus-2027ss-if-the-war-were-to-end-guide",
  heroImage:
    "media/archive_fashion/archive28.png",
  heroImageAlt:
    "COMME des GARCONS HOMME PLUS 2027SS If The War Were To End もし戦争が終わったらを解説するEnclopediaアーカイブガイド画像",
  heroNumber: "27 / IF THE WAR WERE TO END",
  label: "ARCHIVE COLLECTION STUDY",
  title:
    "COMME des GARCONS HOMME PLUS 2027SS『If The War Were To End..』",
  lead:
    "COMME des GARCONS HOMME PLUS 2027SS『If The War Were To End..』。\n\n日本語にすれば、“もし、戦争が終わったら”。\n\nこのテーマは、単なる反戦メッセージではありません。\nそして、ただ明るい服を並べた希望のコレクションでもありません。\n\nHOMME PLUSにおいて、戦争は何度も服の中に現れてきました。\n\n2015SS『Peace Army』では、軍服やミリタリーの記号を、平和の軍隊として反転させた。\n2025AW『To Hell With War』では、フィールドジャケット、軍服、ヘルメット、カモフラージュ、 brass button、軍装の断片を解体し、花や異素材によって戦争の記号を無力化した。\n\nそして2027SS。\n\nここで問われているのは、戦争への怒りそのものではありません。\n戦争が終わった後、人は何を着るのか。\n軍服の記号はどこへ行くのか。\nカモフラージュは、誰から身を隠すための柄ではなくなったとき、何に変わるのか。\n旗は、国家や軍隊のためではなく、人が集まるための布になれるのか。\n\nこのコレクションで印象的なのは、軽さです。\nストライプのシャツ地。\n風を含むようなコート。\nチュニック、ショーツ、スカート、ゆるい重なり。\nパステルに変換されたカモフラージュ。\nパッチワークされたタータン。\n意味を剥がされた旗の色。\n\n戦争の後に残るのは、勝利の制服ではありません。\n緊張をほどいた布です。\n\nEnclopediaでは、2027SS『If The War Were To End..』を、“反戦コレクション”としてではなく、戦争の記号がほどけ、日常の服へ戻っていく過程として読み解きます。",
  keywordLine: [
    "if the war were to end",
    "peace army",
    "to hell with war",
    "homme plus buyback",
  ],
  thesis:
    "2027SS『If The War Were To End..』の重要性は、ミリタリーをさらに激しく解体することではなく、戦争の記号から攻撃性を抜き取り、カモフラージュ、旗、制服、ストライプ、タータンを“戦後の日常服”へ変換した点にあります。",
  whyTitle:
    "なぜHOMME PLUSは、“もし、戦争が終わったら”と問いかけたのか。",
  whyBody:
    "HOMME PLUSにおける戦争のテーマは、一回限りの表現ではありません。\n\n2015SS『Peace Army』では、軍服の装飾性、フィールドジャケット、金ボタン、カモフラージュ、強い柄を使いながら、それを戦闘ではなく平和のための軍隊として反転させました。\n\n2025AW『To Hell With War』では、その姿勢はさらに直接的になります。\n軍服の形、ヘルメット、カモフラージュ、ミリタリーカラー、ユーティリティポケット。\nそれらは戦争のための記号でありながら、花、異素材、解体された構造によって、本来の機能から切り離されていました。\n\nでは、2027SSは何をしているのか。\n\n怒りの後を描いています。\n\n戦争に反対する。\n戦争を地獄へ送る。\nそこからさらに一歩進んで、もし戦争が終わったら、という仮定に入る。\n\nこの仮定が重要です。\n\n“戦争が終わった後”は、単なるハッピーエンドではありません。\n戦争の記号は残ります。\n制服も、旗も、カモフラージュも、勲章も、軍装の形も、完全には消えません。\n\nだから川久保玲は、それらを消すのではなく、意味を変える。\n\nカモフラージュを隠れるための柄から、明るいパステルの抽象柄へ。\n旗を国家や軍隊の所有物から、色のパネルへ。\n軍服の硬さを、シャツ地や柔らかい布の軽さへ。\n制服の規律を、ショーツ、スカート、チュニック、ゆるい重なりへ。\n\nEnclopediaでは、このシーズンを、戦争の終結を祝う服ではなく、戦争の記号を日常へ返却する服として読み解きます。",
  pillars: [
    {
      number: "01",
      title: "AFTER WAR, NOT ANTI-WAR ONLY",
      text:
        "2027SSは、単なる反戦ではなく“戦争の後”を想像するコレクションです。怒りを表現するだけではなく、軍事記号が無力化され、日常へ戻される過程を描いています。",
    },
    {
      number: "02",
      title: "DEMILITARIZED CAMOUFLAGE",
      text:
        "カモフラージュは敵から身を隠すための柄です。しかし2027SSでは、パステルや明るい色に変換され、隠れるためではなく、解放感を生む柄として使われています。",
    },
    {
      number: "03",
      title: "FLAGS WITHOUT NATIONS",
      text:
        "旗は本来、国家、部隊、所属、領土を示す記号です。2027SSでは、その旗が色のパッチやパネルとして服に縫い込まれ、所属の記号ではなく、集まるための布へ変わります。",
    },
    {
      number: "04",
      title: "ARCHIVE VALUE",
      text:
        "2027SSはまだ販売前のシーズンですが、2015SS『Peace Army』、2025AW『To Hell With War』と並べて読むことで、HOMME PLUSのミリタリー解体の流れが明確になります。買取では過去の反戦・軍装モチーフのアーカイブ価値が重要になります。",
    },
  ],
  readingTitle:
    "2015SS『Peace Army』、2025AW『To Hell With War』、そして2027SS『If The War Were To End..』から読むHOMME PLUSの戦争と平和。",
  readingIntro:
    "このシーズンは、戦争を描いた服ではありません。戦争のあとに、軍服、カモフラージュ、旗、制服、装飾、規律がどのように意味を失い、別の布へ変わるのかを描いたコレクションです。2015SSが“平和の軍隊”を作り、2025AWが“戦争そのものを拒否”したとすれば、2027SSは“戦争の記号が解体された後の服”を提示しています。",
  observations: [
    {
      index: "01",
      title:
        "2027SSは、戦争への怒りではなく“戦争後の身体”を描いている",
      text:
        "2025AW『To Hell With War』は、非常に直接的なテーマでした。\n\n戦争への怒り。\n若者が兵士にされる現実。\n軍服の記号を解体すること。\nヘルメットに花を被せ、軍装を異素材で包み、ミリタリーの機能を奪うこと。\n\n一方で2027SS『If The War Were To End..』は、怒りの次にある問いです。\n\nもし戦争が終わったら、人は何を着るのか。\n\n戦争が終わったあと、身体はまだ軍服の記憶を持っています。\nカモフラージュ、旗、ジャケット、規律、集団性。\nそれらはすぐには消えません。\n\nこのコレクションは、戦争そのものではなく、戦争後に残った記号をほどいていく身体を描いています。",
    },
    {
      index: "02",
      title:
        "2015SS『Peace Army』は、軍隊を平和へ反転させた",
      text:
        "2015SS『Peace Army』は、HOMME PLUSにおける反戦表現の重要な起点として見ることができます。\n\nそこでは、軍服の装飾性やフィールドジャケット、金ボタン、カモフラージュ、強い柄が使われていました。\n\nしかし、それらは戦うためではありません。\n“平和の軍隊”として、軍装のイメージを裏返していた。\n\nこの時点では、まだ軍隊という形式が残っています。\nただし、その目的は戦争ではなく平和です。\n\nつまり2015SSは、軍服の意味を反転させるコレクションでした。\n\n2027SSを読むとき、この流れは重要です。\nHOMME PLUSは突然、戦争をテーマにしたわけではありません。\n長い時間をかけて、軍服の意味をずらし続けてきたのです。",
    },
    {
      index: "03",
      title:
        "2025AW『To Hell With War』は、軍装の記号を解体した",
      text:
        "2025AW『To Hell With War』では、戦争に対する拒否がより強く、より直接的に表現されました。\n\nフィールドジャケット。\n軍服の金ボタン。\nヘルメット。\nカモフラージュ。\nミリタリーカラー。\nユーティリティポケット。\n\nこうした軍事記号は、そのまま使われているように見えて、実際には解体されています。\n\nヘルメットには花が被せられる。\n制服は別の素材と衝突する。\n軍服の威圧感は、装飾やパッチワークによって崩される。\n\nここでの服は、軍服への憧れではありません。\n軍服を使いながら、軍服を無力化している。\n\n2027SSは、この“無力化された軍装”のさらに後を描いています。",
    },
    {
      index: "04",
      title:
        "“もし、戦争が終わったら”は、勝利ではなく脱軍事化の問いである",
      text:
        "このシーズンのタイトルは、“戦争が終わった”ではありません。\n\n“もし、戦争が終わったら”。\n\nここには仮定があります。\nまだ現実ではない。\nしかし想像しなければならない。\n\nそして重要なのは、戦争の終わりが勝利の祝典として描かれていないことです。\n\n勝った軍服。\n勲章。\n凱旋。\n国旗。\n英雄。\n\nそうした分かりやすい勝利のイメージではなく、HOMME PLUSが提示したのは、軽く、柔らかく、色のある服でした。\n\nつまりこれは、勝利の服ではなく、脱軍事化の服です。\n戦争の記号から命令、所属、恐怖を抜き取り、身体へ返していく服なのです。",
    },
    {
      index: "05",
      title:
        "パステルカモフラージュは、隠れるためではなく見えるための迷彩である",
      text:
        "カモフラージュは、本来、敵から身を隠すための柄です。\n\n森に紛れる。\n土に紛れる。\n戦場で身体を消す。\n\nしかし2027SSでは、そのカモフラージュがパステルや明るい色へ変換されています。\n\nこれは非常に重要です。\n\nカモフラージュが、隠れるための柄ではなくなっている。\nむしろ、見えるための柄になっている。\n\n戦争のための迷彩が、平和の後には祝祭的な色へ変わる。\n敵から身を隠す布が、人の目を引く布へ変わる。\n\nEnclopediaでは、このパステルカモフラージュを“脱軍事化された迷彩”として読みます。",
    },
    {
      index: "06",
      title:
        "旗は、国家の記号から“色の布”へ戻されている",
      text:
        "旗は、非常に強い記号です。\n\n国家。\n軍隊。\n所属。\n領土。\n勝利。\n占領。\n記念日。\n\n戦争において、旗はしばしば人を動員するための記号になります。\n\nしかし2027SSでは、旗が色のパッチやパネルのように服に取り込まれています。\n\nこれは、旗の意味を弱める行為です。\n\n旗は誰かに従うための記号ではなく、布に戻る。\n国家のための布ではなく、身体を包むための布になる。\n\nこの変換が、2027SSの核心にあります。\n\n戦争が終わったあと、旗はもう命令しない。\nただ風に揺れ、身体に縫い込まれ、色として生き残る。",
    },
    {
      index: "07",
      title:
        "ストライプのシャツ地は、軍服の硬さを日常へ戻す",
      text:
        "2027SSで印象的なのは、ストライプのシャツ地による軽さです。\n\nシャツ地は、軍服とは違います。\n硬い制服ではなく、日常の布です。\n肌に近く、風を通し、汗や暑さと関係する。\n\nHOMME PLUSは、コートやジャケットの形を残しながら、その素材を軽くしている。\n\nここに、戦争後の感覚があります。\n\n形としては、まだ制服やコートの記憶がある。\nしかし素材としては、もう戦闘のためではない。\n\n硬い軍服が、夏の風を通すシャツ地へ変わる。\n\nこれは、服が戦場から日常へ戻るプロセスです。",
    },
    {
      index: "08",
      title:
        "ショーツ、スカート、チュニックは、男性服から規律を抜く",
      text:
        "HOMME PLUSは、男性服の規律を何度も揺らしてきました。\n\nジャケット。\nパンツ。\nシャツ。\nコート。\nスーツ。\n\nこれらは男性服の基本形です。\nしかし2027SSでは、そこにショーツ、スカート、チュニック、ゆるい重なりが入ります。\n\n軍服は、身体を整列させます。\n姿勢を作り、役割を与え、集団の一部にします。\n\n一方で、ショーツやスカート、チュニックは、身体に別の動きを与えます。\n足が見える。\n布が揺れる。\n輪郭が緩む。\n\nこれは、男性服から軍事的な規律を抜くための構造です。",
    },
    {
      index: "09",
      title:
        "タータンは、軍装の歴史を持ちながら、パンクへも逃げる",
      text:
        "タータンは、HOMME PLUSにおいて非常に重要な柄です。\n\n一方で、タータンには軍装や連隊の歴史があります。\n特定の集団、地域、所属を示す柄として使われてきた側面がある。\n\nしかし同時に、タータンはパンクの記号でもあります。\n\n国家や制度に従う柄でありながら、反抗の柄にもなる。\n\n2027SSでパッチワークされたタータンが現れることは、戦争後の服を考えるうえで重要です。\n\n所属の記号としてのタータン。\n反抗の記号としてのタータン。\nその両方が混ざることで、服は単純な平和のイメージではなくなります。\n\n平和は、きれいな無地ではありません。\n過去の記号が継ぎ接ぎされた状態なのです。",
    },
    {
      index: "10",
      title:
        "軽さは、楽天性ではなく、戦争から解放された身体感覚である",
      text:
        "2027SSには、軽さがあります。\n\nしかし、その軽さを単なる楽天性として読むべきではありません。\n\n戦争の服は重い。\n制服は硬い。\n装備は身体を制限する。\nヘルメットは頭を覆う。\nブーツは地面に身体を固定する。\n\nそれに対して、2027SSの服は風を含むように見える。\nシャツ地が揺れ、ショーツが動き、スカートが広がり、柔らかい布が身体から離れる。\n\nこれは、ただ涼しそうな服ではありません。\n\n戦争の緊張から解放された身体の軽さです。\n\nEnclopediaでは、この軽さを“戦後の身体感覚”として読みます。",
    },
    {
      index: "11",
      title:
        "このコレクションは、戦争を忘れるためではなく、戦争の記号を忘れさせないためにある",
      text:
        "明るい色や軽い素材を見ると、このコレクションは戦争を忘れるための服に見えるかもしれません。\n\nしかし、そうではありません。\n\nカモフラージュが残っている。\n旗が残っている。\nコートやジャケットの形が残っている。\nタータンの歴史が残っている。\n\nつまり、戦争の記号は消えていません。\nただ、その意味が変えられている。\n\nこれは忘却ではなく、変換です。\n\n戦争の記号をそのまま保存するのではなく、別の使い方へ移す。\n恐怖のための柄を、解放のための柄へ。\n所属のための旗を、身体のための布へ。\n\n2027SSは、戦争をなかったことにしないための明るさを持っています。",
    },
    {
      index: "12",
      title:
        "“どの戦争か”ではなく、戦争という構造そのものを問うている",
      text:
        "このテーマを見たとき、多くの人は考えるはずです。\n\nどの戦争のことなのか。\n\nしかし、HOMME PLUSの表現は、特定の戦争の名前を直接指しません。\nそれは逃避ではなく、より広い問いに向かうためです。\n\n戦争とは、特定の国だけの問題ではなく、身体を動員し、服を制服化し、旗を意味づけ、若者を兵士に変える構造です。\n\nだから、川久保玲は特定のニュースを服に翻訳するのではなく、戦争という構造そのものを服で扱う。\n\n軍服。\n迷彩。\n旗。\n規律。\n隊列。\n装飾。\n\nそれらが人間の身体に何をするのか。\n\n2027SSは、その構造から身体を引き剥がそうとしているように見えます。",
    },
    {
      index: "13",
      title:
        "販売前のシーズンだからこそ、過去のHOMME PLUSアーカイブ価値が上がる",
      text:
        "2027SSは、まだ販売前のシーズンです。\n\nつまり、今すぐこのシーズンのアイテムを所有することはできません。\n\nしかし、だからこそ重要なのは、過去の関連シーズンを見直すことです。\n\n2015SS『Peace Army』。\n2025AW『To Hell With War』。\nそして、HOMME PLUSが長年扱ってきたミリタリー、テーラリング、カモフラージュ、タータン、装飾的なジャケット。\n\n2027SSによって、それらの過去作は新しい文脈を持ちます。\n\n単なる古いミリタリー風アイテムではなく、HOMME PLUSが戦争と平和をどう扱ってきたかを示すアーカイブになる。\n\nEnclopediaでは、販売前の新作記事を、過去アーカイブの買取・レンタルへ接続する入口として設計します。",
    },
    {
      index: "14",
      title:
        "買取で見るべきなのは、ミリタリー風かどうかではない",
      text:
        "COMME des GARCONS HOMME PLUSの買取では、単にミリタリー風だから価値がある、という見方では不十分です。\n\n2015SS『Peace Army』に近いか。\n2025AW『To Hell With War』のように軍装を解体しているか。\nカモフラージュ、フィールドジャケット、金ボタン、ヘルメット的要素、タータン、装飾、パッチワークがどのように使われているか。\n\n重要なのは、軍服の記号をそのまま使っているかではありません。\nその記号をどう反転し、どう無力化し、どう服として再構築しているかです。\n\nEnclopediaでは、HOMME PLUSを単なるブランド古着としてではなく、シーズン背景、思想、ディテール、状態、現在の需要まで含めて確認します。",
    },
    {
      index: "15",
      title:
        "レンタルで分かるのは、軍服の重さがどれだけほどけているかである",
      text:
        "HOMME PLUSのミリタリー系アーカイブは、画像だけでは分かりにくい部分があります。\n\nジャケットの硬さ。\n布の重さ。\n金ボタンの存在感。\nパッチワークの厚み。\nカモフラージュの見え方。\nタータンの強さ。\n身体がどれだけ規律化されるか。\nあるいは、どれだけ解放されるか。\n\n実際に着ることで、軍服の記号が身体に残っているのか、それとも川久保玲によってほどかれているのかが分かります。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります。",
    },
  ],
  quote:
    "もし戦争が終わったら、軍服は勝者の記念品になるのではない。迷彩は色に戻り、旗は布に戻り、身体は命令から解放される。",
  perspectiveTitle:
    "Enclopediaは、COMME des GARCONS HOMME PLUSを“ミリタリー風の服”ではなく“戦争の記号を解体し、身体へ返すアーカイブ”として扱う。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text:
        "2015SS『Peace Army』、2025AW『To Hell With War』、2027SS『If The War Were To End..』をつなげ、HOMME PLUSが戦争と平和をどう服に変換してきたかを整理します。",
    },
    {
      number: "02",
      title: "EXPERIENCE",
      text:
        "HOMME PLUSのミリタリー系アイテムは、実際に着ることで理解が深まります。布の重さ、軍装の記号、カモフラージュ、パッチワーク、身体の規律と解放をレンタルで体験できます。",
    },
    {
      number: "03",
      title: "ARCHIVE VALUE",
      text:
        "過去のPeace Army、To Hell With War、ミリタリー解体系アーカイブの価値を再文脈化します。Enclopediaではシーズン背景まで含めて確認します。",
    },
  ],
  experienceTitle:
    "COMME des GARCONS HOMME PLUS 2027SSを読む前に、過去の“戦争と平和”のアーカイブ価値を確認する。",
  experienceBody:
    "COMME des GARCONS HOMME PLUS 2027SS『If The War Were To End..』は、まだ販売前のシーズンです。\n\nだからこそ、今見るべきなのは過去の関連アーカイブです。\n\n2015SS『Peace Army』のような、軍服を平和のために反転させたアイテム。\n2025AW『To Hell With War』のような、フィールドジャケット、軍服、ヘルメット、カモフラージュ、花、異素材、パッチワークによって戦争の記号を解体したアイテム。\n\nまた、HOMME PLUS全体に見られるミリタリージャケット、金ボタン、タータン、カモフラージュ、装飾的なテーラリング、軍装を思わせるコートやパンツも、2027SSの視点から再評価できます。\n\nEnclopediaでは、これらを単なる古い服やミリタリー風デザインとしてではなく、川久保玲が戦争、平和、身体、男性服の規律をどう扱ってきたかという文脈で確認します。",
  experienceItems: [
    "COMME des GARCONS HOMME PLUSのタグ・AD表記・シーズンを確認する",
    "2015SS『Peace Army』、2025AW『To Hell With War』に近いアイテムか確認する",
    "フィールドジャケット、軍服、金ボタン、カモフラージュ、ヘルメット的要素、タータンの有無を確認する",
    "軍装の記号が、そのまま使われているのか、解体・反転・装飾化されているのかを確認する",
    "パッチワーク、異素材切替、花柄、装飾、メッシュ、スローガン、特殊なボタン配置を撮影する",
    "肩幅、身幅、着丈、パンツの太さ、シルエットの強さを確認する",
    "黒、カーキ、グレー、ブラウン、パステル、タータンなど色と柄の文脈を確認する",
    "素材表記、品質タグ、サイズ、購入時期、付属品、状態を確認する",
    "シーズン不明の場合もLINEで写真を送る",
  ],
  archiveItemsTitle:
    "2027SS『もし、戦争が終わったら』を入口に、HOMME PLUSの買取・レンタルへ。",
  archiveItemsBody:
    "Enclopediaでは、COMME des GARCONS HOMME PLUSを単なるブランド古着としてではなく、川久保玲の男性服への問い、戦争と平和のテーマ、ミリタリー記号の解体、テーラリング、素材、現在の需要まで含めて見ています。2027SSでこのテーマに触れた方は、過去のHOMME PLUSアーカイブも、まずはLINEでご相談ください。",
  archiveItems: [
    {
      label: "BUYBACK FOCUS 01",
      title: "COMME des GARCONS HOMME PLUS買取ページへ",
      productPath:
        "/brand_buyback/comme-des-garcons-homme-plus",
      productImage: "",
      text:
        "2015SS『Peace Army』、2025AW『To Hell With War』、ミリタリージャケット、カモフラージュ、タータン、装飾的なテーラリングまで。オムプリュスの買取対象と査定視点を確認できます。",
    },
    {
      label: "BUYBACK FOCUS 02",
      title: "COMME des GARCONS買取ページへ",
      productPath:
        "/brand_buyback/comme-des-garcons",
      productImage: "",
      text:
        "COMME des GARCONS、HOMME PLUS、HOMME、SHIRT、JUNYA WATANABEなど、コムデギャルソン全体の買取相談へ進めます。",
    },
    {
      label: "RENTAL FOCUS 03",
      title: "レンタルできるCOMME des GARCONS HOMME PLUSを見る",
      productPath:
        "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
      productImage: "",
      text:
        "COMME des GARCONS HOMME PLUSのミリタリー、テーラリング、カモフラージュ、パッチワークは、実際に着ることで理解が深まります。Enclopediaでオムプリュスのアーカイブを体験できます。",
    },
    {
      label: "LINE FOCUS 04",
      title: "戦争と平和のHOMME PLUSアーカイブを相談する",
      productPath:
        "https://line.me/R/ti/p/@240yzqkh",
      productImage: "",
      text:
        "Peace Army、To Hell With War、カモフラージュ、軍服、金ボタン、タータン、ミリタリー解体系ディテールが分かる写真をLINEでお送りください。Enclopediaが文脈込みで確認します。",
    },
  ],
  finalCta: {
    title:
      "2027SS『もし、戦争が終わったら』を読んだら、次はHOMME PLUSの過去作を確認する。",
    body:
      "COMME des GARCONS HOMME PLUS 2027SS『If The War Were To End..』は、まだ販売前のシーズンです。\nしかし、このテーマによって2015SS『Peace Army』、2025AW『To Hell With War』、そして過去のミリタリー解体系アーカイブは、もう一度新しい意味を持ち始めます。\n\nEnclopediaでは、HOMME PLUSの買取相談を入口に、過去のコレクション理解、レンタル体験、次の所有者への橋渡しまで行います。\nまずはLINEでタグ・品質表示・全体写真・ディテール写真をお送りください。",
    buttonLabel: "COMME des GARCONS HOMME PLUSをLINEで事前査定する",
    buttonHref: "https://line.me/R/ti/p/@240yzqkh",
  },
};

export default collection;